'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var classList = this.compileStyle(_index2.default),
        hint = null;

    if (this.props.hint && this.state.focused && this.value) {
        hint = _react2.default.createElement(
            'div',
            { className: classList.hint },
            _react2.default.createElement('div', { className: classList.hintTriangle }),
            this.value
        );
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        _react2.default.createElement('input', {
            type: 'text',
            value: this.value,
            onChange: this._handleChange,
            ref: this._nativeRef,
            className: classList.input
        }),
        _react2.default.createElement(_reactEventListener2.default, {
            target: window.document.querySelector('body'),
            onMouseMove: this._handleMouseMove,
            onMouseUp: this._handleDragEnd
        }),
        _react2.default.createElement(
            'div',
            { className: classList.progress, onClick: this._handleProgressClick, ref: this._progressRef },
            _react2.default.createElement(
                'div',
                { className: classList.bar, style: { width: this._getProgress() + '%' } },
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: classList.img, onMouseDown: this._handleDragStart },
                    hint
                )
            )
        )
    );
}